import React, { useContext, useEffect, useState } from 'react';
import { Settings, Globe, Building2, Mail, User, Github, Twitter } from 'lucide-react';
import { Button } from '../ui/button';
import { getApiConfiguration } from '@/api/utils';
import { ApiApi, CustomUser } from 'api-client';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '@/contexts/AuthContext';
import { toast } from 'sonner';
import { useTeams } from '@/contexts/TeamsContext';

export const GeneralSettings = () => {
  const { token } = useContext(AuthContext);
  const { user } = useContext(AuthContext);
  const {currentTeam} = useTeams();
  const client = new ApiApi(getApiConfiguration(token));
  const navigate = useNavigate();
  const [data, setData] = useState<CustomUser>({
    id: 0,
    firstName: "",
    lastName: "",
    email: "",
    avatarUrl: "",
    getDisplayName: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      
      await client.apiAuthUserUpdate({
        customUser: {
          avatarUrl: data.avatarUrl,
          getDisplayName: data.getDisplayName,
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
        }
      });

      toast.success('User information updated successfully.');
    } catch (err) {
      toast.error('Failed to update user information. Please try again.');
      console.error('Error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      setData(user)
    }
  }, [user]);
  return (
    <div className="space-y-6">
      <div className="bg-[#0F1629] rounded-xl border border-gray-800/50 p-6">
        <div className="flex items-center space-x-2 mb-6">
          <Settings className="h-5 w-5 text-blue-500" />
          <h2 className="text-lg font-semibold text-white">General Settings</h2>
        </div>

        <div className="space-y-6">
          {/* Account Info - New Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <User className="h-4 w-4 text-gray-400" />
              <h3 className="text-sm font-medium text-white">Account Information</h3>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <label className="text-sm text-gray-400">First Name</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50"
                  placeholder="Enter first name"
                  onChange={(e) => setData({ ...data, firstName: e.target.value })}
                  value={data.firstName}
                />
              </div>

              <div className="space-y-2">
                <label className="text-sm text-gray-400">Last Name</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50"
                  placeholder="Enter last name"
                  onChange={(e) => setData({ ...data, lastName: e.target.value })}
                  value={data.lastName}
                />
              </div>

              <div className="space-y-2">
                <label className="text-sm text-gray-400">Email Address</label>
                <input
                  type="email"
                  className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50"
                  placeholder="Enter email address"
                  onChange={(e) => setData({ ...data, email: e.target.value })}
                  value={data.email}
                  disabled
                />
              </div>

              {/* <div className="space-y-2">
                <label className="text-sm text-gray-400">Avatar</label>
                <div className="flex items-center space-x-3">
                  <div className="h-12 w-12 rounded-full bg-gray-800/30 border border-gray-800"></div>
                  <Button variant="outline" size="sm">Change Avatar</Button>
                </div>
              </div> */}
            </div>

            {/* <div className="space-y-3 pt-4">
              <label className="text-sm text-gray-400">Connected Accounts</label>
              <div className="space-y-3">
                <div className="flex items-center justify-between p-3 bg-gray-800/30 border border-gray-800 rounded-lg">
                  <div className="flex items-center space-x-3">
                    <Github className="h-5 w-5 text-gray-400" />
                    <span className="text-sm text-gray-300">GitHub</span>
                  </div>
                  <Button variant="outline" size="sm">Connect</Button>
                </div>

                <div className="flex items-center justify-between p-3 bg-gray-800/30 border border-gray-800 rounded-lg">
                  <div className="flex items-center space-x-3">
                    <Twitter className="h-5 w-5 text-gray-400" />
                    <span className="text-sm text-gray-300">Twitter</span>
                  </div>
                  <Button variant="outline" size="sm">Connect</Button>
                </div>
              </div>
            </div> */}
          </div>

          {/* Team Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <Building2 className="h-4 w-4 text-gray-400" />
              <h3 className="text-sm font-medium text-white">Team Information</h3>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <label className="text-sm text-gray-400">Team Name</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50"
                  placeholder="Enter team name"
                  disabled
                  // onChange={(e) => setData({ ...data, teamName: e.target.value })}
                  value={currentTeam?.name || ''}
                />
              </div>

              {/* <div className="space-y-2">
                <label className="text-sm text-gray-400">Display Name</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50"
                  placeholder="Enter display name"
                  onChange={(e) => setData({ ...data, getDisplayName: e.target.value })}
                  value={data.getDisplayName}
                />
              </div> */}
            </div>
          </div>

          {/* Contact Info */}
          {/* <div className="space-y-4 pt-6 border-t border-gray-800">
            <div className="flex items-center space-x-2">
              <Mail className="h-4 w-4 text-gray-400" />
              <h3 className="text-sm font-medium text-white">Contact Information</h3>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <label className="text-sm text-gray-400">Contact Email</label>
                <input
                  type="email"
                  className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50"
                  placeholder="Enter contact email"
                  // onChange={(e) => setData({ ...data, contactEmail: e.target.value })}
                  // value={data.contactEmail}
                />
              </div>

              <div className="space-y-2">
                <label className="text-sm text-gray-400">Support Email</label>
                <input
                  type="email"
                  className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50"
                  placeholder="Enter support email"
                  // onChange={(e) => setData({ ...data, supportEmail: e.target.value })}
                  // value={data.supportEmail}
                />
              </div>
            </div>
          </div> */}

          {/* Preferences */}
          <div className="space-y-4 pt-6 border-t border-gray-800">
            <div className="flex items-center space-x-2">
              <Globe className="h-4 w-4 text-gray-400" />
              <h3 className="text-sm font-medium text-white">Preferences</h3>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  id="timezone"
                  className="h-4 w-4 rounded border-gray-700 bg-gray-800/30 text-blue-500 focus:ring-blue-500/50"
                  disabled
                />
                <label htmlFor="timezone" className="text-sm text-gray-300">
                  Use team timezone for all dates and times
                </label>
              </div>

              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  id="reports"
                  className="h-4 w-4 rounded border-gray-700 bg-gray-800/30 text-blue-500 focus:ring-blue-500/50"
                  disabled
                />
                <label htmlFor="reports" className="text-sm text-gray-300">
                  Enable weekly security reports
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center justify-end space-x-3 mt-8 pt-6 border-t border-gray-800">
          <Button variant="outline">Cancel</Button>
          <Button onClick={handleSubmit}>Save Changes</Button>
        </div>
      </div>
    </div>
  );
};